import Vue from "vue";

import { Component, Prop } from "vue-property-decorator";

export interface IVideoModel {
    source: string;
    title: string;
}

@Component
export default class VideoPlayer extends Vue {

    @Prop()
    value: IVideoModel;


}



// WEBPACK FOOTER //
// ./ClientApp/components/video-player/video-player.ts